import React from 'react';
const Home = () =>{
  return (
    <div>
        &nbsp;
    </div>
  );
}
export default Home;